(() => {
  if (window.__taneraKachingHelpers) return;
  window.__taneraKachingHelpers = true;
  window.__taneraKachingSwatchScroll = true;

  /* ============================================================
     Helfer rund um die Kaching-Apps:

     TEIL 1  Farbe aus der Adresszeile auf der Produktseite wiederherstellen
     TEIL 2  Scroll nach oben beim Klick auf Swatch oder Bundle-Box (nur mobil)
     TEIL 3  "Weiter shoppen"-Button im leeren Kaching-Warenkorb
     ============================================================ */

  var ROOT_SELECTOR = '.kaching-bundles';
  var TRIGGER_SELECTOR =
    '.kaching-bundles__swatch-buttons__button, .kaching-bundles__swatch, .kaching-bundles__bar';

  var MOBILE_MAX_WIDTH = 749;
  var GUARD_MS = 3200;
  var DURATION_MS = 320;
  var THROTTLE_MS = 200;
  var RETRY_DELAYS = [300, 800, 1400, 2200];

  var rafId = null;
  var retryTimers = [];
  var lastRunAt = 0;
  var interrupted = false;
  var skipNextScroll = false;

  /* ============================================================
     TEIL 1: Farbe aus der Adresszeile wiederherstellen

     Kommt man von einer Produktkarte mit ?variant=..., waehlt Kaching Bundles
     beim Laden trotzdem seine eigene Standardvariante und schreibt die
     Adresszeile sogar um. Deshalb wird der Parameter SOFORT beim Laden
     gemerkt und danach das passende Farbfeld angeklickt. Kachings Felder
     tragen data-value mit dem Optionswert, z. B. "Peach".
     ============================================================ */
  var urlVariantMatch = window.location.search.match(/[?&]variant=(\d+)/);
  var wantedVariantId = urlVariantMatch ? urlVariantMatch[1] : null;

  function restoreColorFromUrl() {
    if (!wantedVariantId) return;

    var dataScript = document.querySelector('[data-product-variants-json]');
    if (!dataScript) return;

    var variants;
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (error) {
      return;
    }

    var wanted = variants.find(function (v) {
      return String(v.id) === wantedVariantId;
    });
    if (!wanted || !wanted.options) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts++;
      if (attempts > 25) {
        window.clearInterval(timer);
        return;
      }

      var bar =
        document.querySelector('.kaching-bundles__bar--selected') ||
        document.querySelector('.kaching-bundles__bar');
      if (!bar) return;

      var buttons = bar.querySelectorAll('.kaching-bundles__swatch-buttons__button[data-value]');
      if (!buttons.length) {
        window.clearInterval(timer);
        return;
      }

      var target = null;
      Array.prototype.forEach.call(buttons, function (button) {
        if (target) return;
        if (wanted.options.indexOf(button.getAttribute('data-value')) !== -1) target = button;
      });

      window.clearInterval(timer);
      if (!target) return;
      if (target.className.indexOf('--selected') !== -1) return;

      skipNextScroll = true;
      target.click();
    }, 200);
  }

  /* ============================================================
     TEIL 2: Scroll nach oben beim Klick auf Swatch oder Bundle-Box (nur mobil)
     ============================================================ */
  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX_WIDTH + 'px)').matches;
  }

  function cancelAnimation() {
    if (rafId === null) return;
    window.cancelAnimationFrame(rafId);
    rafId = null;
  }

  function clearRetries() {
    retryTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    retryTimers = [];
  }

  function onUserInput() {
    interrupted = true;
    cancelAnimation();
    clearRetries();
    detachUserInput();
  }

  function attachUserInput() {
    ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
      window.addEventListener(type, onUserInput, { passive: true });
    });
  }

  function detachUserInput() {
    ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
      window.removeEventListener(type, onUserInput, { passive: true });
    });
  }

  function currentY() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  /*
    Eigene Animation statt behavior: 'smooth', weil der native Smooth-Scroll
    seine Dauer selbst bestimmt und bei grosser Distanz traege wird.

    Mehrere Anlaeufe, weil Kaching nach einem Klick die Bundle-Box neu aufbaut
    und dabei die vorherige Scrollposition wiederherstellt. Gemessen: direkt
    nach dem Klick wird jede Scrollanweisung zurueckgesetzt, ab etwa 1500 ms
    greift sie.
  */
  function glideToTop() {
    if (interrupted) return;

    var startY = currentY();
    if (startY <= 2) return;

    cancelAnimation();
    var startTime = null;

    function step(now) {
      if (interrupted) {
        rafId = null;
        return;
      }
      if (startTime === null) startTime = now;

      var progress = Math.min((now - startTime) / DURATION_MS, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, Math.round(startY * (1 - eased)));

      if (progress < 1) {
        rafId = window.requestAnimationFrame(step);
      } else {
        rafId = null;
      }
    }

    rafId = window.requestAnimationFrame(step);
  }

  function run() {
    var now = Date.now();
    if (now - lastRunAt < THROTTLE_MS) return;
    lastRunAt = now;

    interrupted = false;
    cancelAnimation();
    clearRetries();
    detachUserInput();
    attachUserInput();

    window.__taneraKachingSwatchSelection = true;
    window.clearTimeout(window.__taneraKachingSwatchSelectionTimer);
    window.__taneraKachingSwatchSelectionTimer = window.setTimeout(function () {
      window.__taneraKachingSwatchSelection = false;
      detachUserInput();
    }, GUARD_MS);

    glideToTop();

    RETRY_DELAYS.forEach(function (delay) {
      retryTimers.push(
        window.setTimeout(function () {
          if (interrupted) return;
          if (currentY() <= 2) return;
          glideToTop();
        }, delay)
      );
    });
  }

  function findTrigger(event) {
    var target = event.target;
    if (!(target instanceof Element)) return null;

    var trigger = target.closest(TRIGGER_SELECTOR);
    if (!trigger) return null;

    return trigger.closest(ROOT_SELECTOR) ? trigger : null;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (skipNextScroll) {
        skipNextScroll = false;
        return;
      }
      if (!isMobile()) return;
      if (!findTrigger(event)) return;
      run();
    },
    true
  );

  /* ============================================================
     TEIL 3: "Weiter shoppen"-Button im leeren Kaching-Warenkorb

     Der Warenkorb-Drawer stammt von der Kaching-Cart-App, nicht aus
     snippets/cart-drawer.liquid. Dawns eigener Leer-Zustand samt Button ist
     zwar im HTML vorhanden, wird aber nie angezeigt (Hoehe 0, visibility
     hidden). Aenderungen an der Theme-Datei bleiben deshalb wirkungslos.

     WICHTIG zu den Farben: Innerhalb des Kaching-Warenkorbs sind die
     Farbvariablen des Themes (--color-button, --color-button-text) nicht
     gesetzt. Die Theme-Klasse "button" allein ergab deshalb schwarze Schrift
     auf schwarzem Grund. Farben werden hier ausdruecklich gesetzt.
     ============================================================ */
  var EMPTY_CART_LABEL = 'Weiter shoppen';
  var EMPTY_CART_TARGET = 'collections/produkte';
  var EMPTY_CONTENT_SELECTOR = '.kaching-cart__empty-cart-central-content-main';

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function addEmptyCartButton() {
    var host = document.querySelector(EMPTY_CONTENT_SELECTOR);
    if (!host) return;
    if (host.querySelector('[data-tanera-empty-cta]')) return;

    var link = document.createElement('a');
    link.setAttribute('data-tanera-empty-cta', '');
    link.href = shopRoot().replace(/\/$/, '') + '/' + EMPTY_CART_TARGET;
    link.textContent = EMPTY_CART_LABEL;

    link.style.display = 'inline-flex';
    link.style.alignItems = 'center';
    link.style.justifyContent = 'center';
    link.style.marginTop = '20px';
    link.style.padding = '12px 32px';
    link.style.background = '#000';
    link.style.color = '#fff';
    link.style.textDecoration = 'none';
    link.style.fontFamily = 'var(--font-body-family)';
    link.style.fontSize = '1.5rem';
    link.style.letterSpacing = '0.1rem';
    link.style.borderRadius = 'var(--buttons-radius, 0)';

    host.appendChild(link);
  }

  // Der Drawer wird von der App erst beim Oeffnen aufgebaut und bei jeder
  // Aenderung neu gezeichnet, deshalb dauerhaft beobachten.
  function watchEmptyCart() {
    addEmptyCartButton();
    new MutationObserver(function () {
      addEmptyCartButton();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    restoreColorFromUrl();
    watchEmptyCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
